import styled from 'styled-components';
import { palette } from 'styled-theme';
import { Carousel as RRCarousel } from 'react-responsive-carousel';
import Text from 'reusecore/src/elements/Text';

const Carousel = styled(RRCarousel)`
  .carousel.carousel-slider {
    cursor: pointer;
  }

  .carousel.carousel-slider .control-arrow {
    width: 55px;
    height: 55px;
    @media screen and (max-width: 580px) {
      width: 30px;
      height: 30px;
    }
    top: 50%;
    margin-top: -30px;
    background-color: rgba(0, 0, 0, 0.49);
    border-radius: 100%;
    font-size: 22px;
    padding: 0;
    font-family: 'ionicons';

    &.control-prev {
      left: 10px;

      &:before {
        border: 0;
        content: '\\f288';
      }
    }

    &.control-next {
      right: 10px;

      &:before {
        border: 0;
        content: '\\f28a';
      }
    }
  }

  .carousel .thumbs-wrapper {
    margin: 15px 0;

    .thumbs {
      padding: 0;
      margin: 0;

      .thumb {
        width: calc(20% - 8px) !important;
        cursor: pointer;
        height: 100px;
        box-sizing: border-box;
        padding: 0;
        overflow: hidden;
        margin-right: 10px;
        border: 1px solid rgba(255, 255, 255, 0.6);
        border-radius: 2px;

        @media screen and (min-width: 768px) and (max-width: 1023px) {
          width: calc(33.333% - 6px) !important;
        }

        @media screen and (max-width: 580px) {
          width: calc(33.333% - 6px) !important;
        }

        &.selected {
          padding: 0;
          border-bottom: 3px solid #00bcd4;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .control-next {
      &.control-arrow {
        right: 0;
        width: 40px;
        height: calc(100% - 3px);
        top: 0;
        margin-top: 0;
        background-color: rgba(0, 0, 0, 0.6);
        padding: 0;
      }
    }

    .control-prev {
      &.control-arrow {
        left: 0;
        width: 40px;
        height: calc(100% - 3px);
        top: 0;
        margin-top: 0;
        background-color: rgba(0, 0, 0, 0.6);
        padding: 0;
      }
    }
  }
`;

const DescriptionWrapper = styled('div')`
  padding: 20px 35px;
`;

const InfoBoxWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 20px;
  ${'' /* padding: 20px 35px; */};
`;
const PricingSection = styled('div')`
  background-color: #f8f8f8;
  padding: 10px 35px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
`;

const AlignCenterWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
`;

const PriceTag = styled('div')`
  padding: 10px;
  background-color: #ffedd6;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-radius: 3px;
`;

const TagName = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  color: ${palette('text', 0)};
`;

const TagBullet = styled('div')`
  width: 10px;
  height: 10px;
  display: flex;
  border-radius: 10px;
  background-color: #f2a43e;
  flex-shrink: 0;
  margin-right: 10px;
`;

const GridPostsHolder = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 -8px;
  padding: 0 35px;
`;

const SectionWrapper = styled('div')`
  padding: 50px 0;
  @media (max-width: 580px) {
    padding: 25px 0;
  }
`;

export {
  DescriptionWrapper,
  AlignCenterWrapper,
  PriceTag,
  TagName,
  TagBullet,
  PricingSection,
  InfoBoxWrapper,
  GridPostsHolder,
  Carousel,
  SectionWrapper,
};
